export default __webpack_public_path__ + "static/media/single-hero.bbfa133e.png";